module.exports = __webpack_public_path__ + "img/img-test-2.200473d7.png";